import Header from '../../components/Header/Header';
import { useEffect, useState } from 'react';
import { getGoals, getSchoolWithColumns } from '../../utils/functions';
import { Link } from 'react-router-dom';
import constants from '../../utils/constants';
import { MetaText } from '../../components/MetaText/MetaText';
import Footer from '../../components/Footer/Footer';

function ISSLCSchool(props) {
    const userRole = localStorage.getItem(constants.roleKey);
    const [school, setSchool] = useState();
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [sortBy, setSortBy] = useState();

    useEffect(() => {
        const getAndSetSchool = async () => {
            const theSchool = await getSchoolWithColumns('ISSLC', props.match.params.schoolId);
            setSchool(theSchool[0]);
        };

        const getAndSetRows = async () => {
            const theRows = await getGoals('row', 'ISSLC', { hideForPrincipal: true }, props.match.params.schoolId);
            setRows(theRows);
        };

        const getAndSetColumns = async () => {
            const theColumns = await getGoals(
                'column',
                'ISSLC',
                { hideForPrincipal: true },
                props.match.params.schoolId,
            );
            setColumns(theColumns);
        };

        getAndSetSchool();
        getAndSetRows();
        getAndSetColumns();
    }, []);

    const statusButtons = [
        {
            title: 'Exceed',
            bgcolor: '#006AA3',
            txtcolor: '#FFFFFF',
            key: 'exceed',
        },
        {
            title: 'Met',
            bgcolor: '#00B050',
            txtcolor: '#FFFFFF',
            key: 'meet',
        },
        {
            title: 'Partially Met',
            bgcolor: '#DFD60D',
            txtcolor: '#FFFFFF',
            key: 'partially_meet',
        },
        {
            title: 'Underperform',
            bgcolor: '#DB4D36',
            txtcolor: '#ffffff',
            key: 'underperform',
        },
    ];

    const legendObject = {
        title: 'Matrix Key',
        P: 'Principal',
        T: 'Teachers',
        PA: 'Para Educators',
        D: 'Distinct Employees',
        PAR: 'Parents',
        SUP: 'Supervision',
        CuSUP: 'Program Supervision',
        SB: 'School Board',
        S: 'Superintendent',
        C: 'Coaches',
    };

    const onClickSort = async (sortKey) => {
        if (sortBy === sortKey) {
            setSortBy();
            return;
        }

        const sortObject = {
            status: sortKey,
        };
        const rows = await getGoals('row', 'ISSLC', sortObject, props.match.params.schoolId);
        setRows(rows);
        setSortBy(sortKey);
    };

    const displayCellText = (param) => {
        const maxLength = 130;

        if (param.data?.matrix_description) {
            if (param.data?.matrix_description.length < maxLength) {
                return param.data?.matrix_description;
            }
            return `${param.data?.matrix_description.substring(0, maxLength)}...`;
        }

        return '';
    };

    const displayLegend = (legendObject) => {
        const elementsToReturn = [];

        for (const item in legendObject) {
            if (item === 'title') {
                continue;
            }

            const element = (
                <span key={item} className={'legend-item-wrapper'}>
                    <span className={'legend-item-label'}>{`${item} = `}</span>
                    <span className={'legend-item-description'}>{`${legendObject[item]}`}</span>
                </span>
            );

            elementsToReturn.push(element);
        }
        return elementsToReturn;
    };

    const getAwspText = (rowId) => {
        let awsp = 'Select AWSP Criteria';
        school.parameters.forEach((param) => {
            if (param.row_id === rowId && Array.isArray(param.awsp) && param.awsp?.length) {
                awsp = param.awsp.map((awsp, index) => {
                    return (
                        <>
                            {awsp}
                            {index !== param.awsp.length - 1 ? ',' : ''}
                            <br />
                        </>
                    );
                });
            }
        });
        return awsp;
    };

    return (
        <>
            <Header title={school?.name} />
            <main className={''}>
                <div className={'edit-form-info container'}>
                    <h3>
                        <Link to={'/'}>Dashboard</Link>
                    </h3>
                    <h3>
                        <Link to={'/ISSLC'}>Schools</Link>
                    </h3>
                    <h3>{school?.name}</h3>
                </div>

                <div className={'filters-container container'}>
                    <h4>Sort by</h4>
                    {statusButtons.map((item, index) => (
                        <div
                            key={index}
                            className={`sort-item${sortBy === item.key ? ' selected' : ''}`}
                            onClick={() => onClickSort(item.key)}
                        >
                            <div className={'sort-item-container'} style={{ backgroundColor: item.bgcolor }}>
                                <h4 style={{ color: item.txtcolor }}>{item.title}</h4>
                            </div>
                        </div>
                    ))}
                </div>

                <div className={'edit-form container'}>
                    <h3 className={'label'}>Narrative:</h3>
                    <MetaText schoolId={props.match.params.schoolId} metaKey={'narrative'} role={userRole} />
                </div>

                <div className={' edit-form mb-2'}>
                    {(userRole === 'admin' || userRole === 'school-admin') && (
                        <Link to={`/isslc/edit-column/${props.match.params.schoolId}/`}>
                            <button className={'mt-1 ml-5 mb-1'} type={'submit'} style={{ float: 'left' }}>
                                Edit Dashboard Components
                            </button>
                        </Link>
                    )}
                </div>

                <div className={'grid-container single-school-table'}>
                    <table className={'grid-table center'} cellSpacing={0}>
                        <tbody>
                            <tr>
                                <td className={'row-header-large table-header'} style={{ width: '250px' }}>
                                    AWSP
                                </td>
                                <td className={'table-header'} style={{ width: '200px' }}>
                                    Leadership Standards
                                </td>
                                {columns.map((col, index) => (
                                    <th className={'column-header'} key={index} scope={'col'}>
                                        {col.name}
                                    </th>
                                ))}
                            </tr>
                            {school &&
                                rows &&
                                columns &&
                                rows.map((row, index) => {
                                    return (
                                        <tr key={index}>
                                            <th
                                                className={`row-header-${index % 2}`}
                                                style={{ borderRight: '1px solid black', textAlign: 'left' }}
                                            >
                                                {userRole === 'admin' ? (
                                                    <Link
                                                        to={`/isslc/awsp-edit/${props.match.params.schoolId}/${row._id}`}
                                                    >
                                                        {school && getAwspText(row._id)}
                                                    </Link>
                                                ) : (
                                                    <span>{school && getAwspText(row._id)}</span>
                                                )}
                                            </th>
                                            <th
                                                className={`row-header-${index % 2}`}
                                                style={{ maxWidth: '170px' }}
                                                scope={'row'}
                                            >
                                                <span>{row.name}</span>
                                            </th>
                                            {columns.map((col, col_ind) => {
                                                let Cell;
                                                school.parameters.forEach((param) => {
                                                    if (
                                                        param.column_id &&
                                                        param.row_id &&
                                                        param.column_id === col._id &&
                                                        param.row_id === row._id
                                                    ) {
                                                        Cell = (
                                                            <td key={col_ind} className={`cell ${param.data?.status}`}>
                                                                <Link
                                                                    to={`/isslc-edit/${school._id}/${col._id}/${row._id}`}
                                                                >
                                                                    <span>{displayCellText(param)}</span>
                                                                    <span style={{ marginTop: 'auto', color: '#fff' }}>
                                                                        {param.data?.something?.join(', ')}
                                                                    </span>
                                                                </Link>
                                                            </td>
                                                        );
                                                    }
                                                });

                                                if (!Cell) {
                                                    Cell = (
                                                        <td key={col_ind} className={`cell row-header-${index % 2}`}>
                                                            <Link
                                                                to={`/isslc-edit/${school._id}/${col._id}/${row._id}`}
                                                            >
                                                                {'-'}
                                                            </Link>
                                                        </td>
                                                    );
                                                }
                                                return Cell;
                                            })}
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </table>
                    <section className={'table-legend-section'}>
                        <span className={'legend-title'}>{`${legendObject.title}: `}</span>
                        <span className={'legend-items'}>{displayLegend(legendObject)}</span>
                    </section>
                </div>
            </main>
            <Footer />
        </>
    );
}

export default ISSLCSchool;
